// src/components/NavBar.js
import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import LoginButton from "./LoginButton";

const NavBar = () => {
  const { isAuthenticated, logout } = useAuth0();

  return (
    <nav className="nav-container">
      {/* ... otros enlaces de tu menú ... */}

      {!isAuthenticated && <LoginButton />}

      {isAuthenticated && (
        <button
          onClick={() =>
            logout({ returnTo: window.location.origin })
          }
          className="btn btn-secondary text-white"
        >
          Cerrar sesión
        </button>
      )}
    </nav>
  );
};

export default NavBar;
